/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { accountSettingsDefaultBillingShippingStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping";
import { GridOffset } from "@insite/mobius/GridContainer";
import { addressWrapper, changeLink } from "@monsma/App/WidgetExtensions/AccountSettings/AccountSettingsExtension";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

accountSettingsDefaultBillingShippingStyles.customerSelectorGridContainer = {
    css: css`
        margin-left: 15px;
        margin-bottom: 15px;

        > ${GridOffset} {
            ${screen("lt", "sm")} {
                width: 100%;
            }
        }
    `,
    gap: 15,
};

(accountSettingsDefaultBillingShippingStyles as any).pickUpLocation = {
    gridContainer: { gap: 5 },
    headingGridItem: { width: 12 },
    headerText: {
        variant: "h5",
        css: css`
            margin-bottom: 0;
        `,
    },
    changeLink: { ...changeLink },
    warehouseGridItem: {
        width: 12,
    },
    warehouseAddress: {
        nameText: {
            as: "p",
        },
    },
    addressesWrapper: {
        ...addressWrapper,
        css: css`
            ${addressWrapper.css};
            width: 100%;
        `,
    },
};

accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGridItem = {
    width: 12,
    css: css`
        padding-top: 25px;
    `
};

accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGroup = {};
